import { Result } from 'antd';
import { useTranslation } from 'react-i18next';

export function ComingSoonPage({ titleKey, day }: { titleKey: string; day: number | undefined }) {
  const { t } = useTranslation();
  return (
    <Result
      status="info"
      title={t(titleKey)}
      subTitle={day ? t('pages.comingSoonDay', { day }) : t('pages.comingSoon')}
    />
  );
}
